<template>
  <div>
    <b-row>
      <b-col
        v-for="item in avisos"
        :key="item.id"
        cols="12"
        md="4"
        class="d-flex"
      >
        <b-card
          :title="item.titulo"
          class="w-100"
        >
          <b-row>
            <b-col align="left">
              <b-badge
                size="xs"
                variant="primary"
              >{{
                new Date(item.data) | formatDate
              }}</b-badge>
            </b-col>
            <b-col align="right">
              <b-button
                variant="outline-primary"
                size="sm"
                align="right"
                :to="`/aviso/${item.id}`"
              >
                ver <feather-icon icon="ArrowRightIcon" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more">
        Já carregamos todos os avisos =)
      </div>
      <no-content-aviso slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import NoContentAviso from './NoContentAviso.vue'

export default {
  components: {
    InfiniteLoading,
    NoContentAviso,
  },
  data() {
    return {
      pagination: { page: 1, size: 10 },
    }
  },
  computed: {
    avisos() {
      return this.$store.state.mural.avisos
    },
  },
  beforeCreate() {
    this.$store.dispatch('mural/clear')
  },
  methods: {
    infiniteHandler($state) {
      this.$store
        .dispatch('mural/fetchAvisos', { pagina: this.pagination.page })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.pagination.page += 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
  },
}
</script>
